let thumbs_swiper;
if (window.innerWidth > 1040) {
  thumbs_swiper = new Swiper(".thumbnails", {
    spaceBetween: 20,
    slidesPerView: "auto",
    // freeMode: true,
    // watchSlidesProgress: true,
    direction: "vertical",
    observer: true,
    observeParents: true,
  });
}

const main_swiper_desktop = new Swiper(".slideshow.product-slideshow.desktop", {
  // Optional parameters
  slidesPerView: 1,
  observer: true,
  observeParents: true,
  // mousewheel: true,
  // freeMode: true,
  // direction: 'vertical',
  thumbs: {
    swiper: thumbs_swiper,
  },
  navigation: {
    nextEl: ".slick-product-next",
    prevEl: ".slick-product-prev",
  },
});

const main_swiper_mobile = new Swiper(".slideshow.product-slideshow.mobile", {
  // Optional parameters
  slidesPerView: 1,
  observer: true,
  observeParents: true,
  thumbs: {
    swiper: thumbs_swiper,
  },
  navigation: {
    nextEl: ".slick-product-next",
    prevEl: ".slick-product-prev",
  },
});

const color_options = document.querySelectorAll(
  ".option-selector__btns input.js-option"
);
const variant_images = document.querySelectorAll(
  ".slideshow.product-slideshow .slide"
);
const thumb_images = document.querySelectorAll(".thumbnails.swiper .thumbnail");
const color_options_label = document.querySelectorAll(
  ".option-selector__btns .opt-label"
);
const main_container = document.querySelectorAll(
  ".slideshow.product-slideshow .swiper-wrapper"
);
const thumbs_container = document.querySelectorAll(
  ".thumbnails.swiper .swiper-wrapper"
);
let data_images = [];
let data_thumbs = [];
let active_option = "";

function initDefaultOptions() {
  const variantData = theme.OptionManager.getCurrentVariantData(
    $(".product-form")
  );
  active_option = `${variantData.option1},${variantData.option3}`;
  const productData = theme.OptionManager.getProductData($(".product-form"));
  productData.variants.forEach((variant) => {
    const groupName = `${variant.option1},${variant.option3}`;
    if (
      data_images.some((imageObject) => imageObject.option_name === groupName)
    ) {
      return;
    }
    const img_object = {
      option_name: groupName,
      option_images: [
        ...(document.querySelectorAll(
          `.slideshow.product-slideshow.desktop [data-variant-image-group="${groupName}"]`
        ).length > 0
          ? document.querySelectorAll(
              `.slideshow.product-slideshow.desktop [data-variant-image-group="${groupName}"]`
            )
          : document.querySelectorAll(
              `.slideshow.product-slideshow.desktop [data-variant-image-group]`
            )),
      ],
    };
    data_images.push(img_object);

    if (window.innerWidth > 1040) {
      const thumb_object = {
        option_name: groupName,
        option_images: [
          ...(document.querySelectorAll(
            `.thumbnails.swiper [data-variant-image-group="${groupName}"]`
          ).length > 0
            ? document.querySelectorAll(
                `.thumbnails.swiper [data-variant-image-group="${groupName}"]`
              )
            : document.querySelectorAll(
                `.thumbnails.swiper [data-variant-image-group]`
              )),
        ],
      };
      data_thumbs.push(thumb_object);
    }
  });

  // color_options.forEach((option) => {
  //   console.log("option", option);
  //   if (option.checked === true) {
  //     active_option = option.value;
  //   }

  // const img_object = {
  //   option_name: option.value,
  //   option_images: [
  //     ...(document.querySelectorAll(
  //       `.slideshow.product-slideshow.desktop [data-variant-image-group="${option.value}"]`
  //     ).length > 0
  //       ? document.querySelectorAll(
  //           `.slideshow.product-slideshow.desktop [data-variant-image-group="${option.value}"]`
  //         )
  //       : document.querySelectorAll(
  //           `.slideshow.product-slideshow.desktop [data-variant-image-group]`
  //         )),
  //   ],
  // };
  //   data_images.push(img_object);

  //   if (window.innerWidth > 1040) {
  //     const thumb_object = {
  //       option_name: option.value,
  //       option_images: [
  //         ...(document.querySelectorAll(
  //           `.thumbnails.swiper [data-variant-image-group="${option.value}"]`
  //         ).length > 0
  //           ? document.querySelectorAll(
  //               `.thumbnails.swiper [data-variant-image-group="${option.value}"]`
  //             )
  //           : document.querySelectorAll(
  //               `.thumbnails.swiper [data-variant-image-group]`
  //             )),
  //       ],
  //     };
  //     data_thumbs.push(thumb_object);
  //   }
  // });

  setTimeout(() => {
    const active_img = data_images.find(
      (el) => el.option_name === active_option
    );

    variant_images.forEach((image) => {
      image.remove();
    });

    active_img.option_images.forEach((el) => {
      main_container.forEach((item) => {
        item.insertAdjacentHTML("beforeend", el.innerHTML);
      });
    });

    main_swiper_desktop.update();
    main_swiper_mobile.update();

    if (window.innerWidth > 1040) {
      const active_thumb = data_thumbs.find(
        (el) => el.option_name === active_option
      );

      thumb_images.forEach((image) => {
        image.remove();
      });

      active_thumb.option_images.forEach((el) => {
        thumbs_container.forEach((item) => {
          item.insertAdjacentHTML("beforeend", el.innerHTML);
        });
      });

      thumbs_swiper.update();
    }
  }, 300);
}

function setOPtions() {
  $(window).on("cc-variant-updated", (e, args) => {
    // const data = theme.OptionManager.getCurrentVariantData($(".product-form"));
    const curent_value = `${args.variant.option1},${args.variant.option3}`;
    // console.log(`______ ${args.option1}, ${args.option3}`);
    // color_options_label.forEach((option) => {
    // option.addEventListener("click", () => {
    // console.log(option.dataset.variantGroup);
    // const curent_value = option.dataset.variantGroup;
    // console.log("OPTIONDATASET", option.dataset.variantGroup);
    const current_variant_images = document.querySelectorAll(
      ".slideshow.swiper .swiper-slide"
    );
    const current_variant_thumbs = document.querySelectorAll(
      ".thumbnails.swiper .swiper-slide"
    );

    const active_img = data_images.find(
      (el) => el.option_name === curent_value
    );
    if (!active_img) {
      return;
    }
    current_variant_images.forEach((image) => {
      image.remove();
    });

    active_img.option_images.forEach((el) => {
      main_container.forEach((item) => {
        item.insertAdjacentHTML("beforeend", el.innerHTML);
      });
    });

    main_swiper_desktop.update();
    main_swiper_mobile.update();

    if (window.innerWidth > 1040) {
      current_variant_thumbs.forEach((image) => {
        image.remove();
      });

      const active_thumb = data_thumbs.find(
        (el) => el.option_name === curent_value
      );

      active_thumb.option_images.forEach((el) => {
        thumbs_container.forEach((item) => {
          item.insertAdjacentHTML("beforeend", el.innerHTML);
        });
      });
      thumbs_swiper.update();
    }
  });
  // });
}

function videoPlay() {
  main_swiper_desktop.on("realIndexChange", function () {
    setTimeout(() => {
      const active_slide = document.querySelector(
        ".main-image .swiper-slide-active"
      );
      const prev_slide = document.querySelector(".swiper-slide-prev");
      const next_slide = document.querySelector(".swiper-slide-next");

      if (active_slide) {
        const poster = active_slide.querySelector(".product-media__poster");
        const video = active_slide.querySelector("video");
        if (video) {
          poster.style.display = "none";
          if (video.paused) {
            video.play();
          }
        }
      }

      if (prev_slide) {
        const poster = prev_slide.querySelector(".product-media__poster");
        const video = prev_slide.querySelector("video");
        if (video) {
          poster.style.display = "block";
          video.pause();
        }
      }

      if (next_slide) {
        const poster = next_slide.querySelector(".product-media__poster");
        const video = next_slide.querySelector("video");
        if (video) {
          poster.style.display = "block";
          video.pause();
        }
      }
    }, 100);
  });
  main_swiper_mobile.on("realIndexChange", function () {
    setTimeout(() => {
      const active_slide = document.querySelector(".swiper-slide-active");
      const prev_slide = document.querySelector(".swiper-slide-prev");
      const next_slide = document.querySelector(".swiper-slide-next");

      if (active_slide) {
        const poster = active_slide.querySelector(".product-media__poster");
        const video = active_slide.querySelector("video");
        if (video) {
          poster.style.display = "none";
          if (video.paused) {
            video.play();
          }
        }
      }

      if (prev_slide) {
        const poster = prev_slide.querySelector(".product-media__poster");
        const video = prev_slide.querySelector("video");
        if (video) {
          poster.style.display = "block";
          video.pause();
        }
      }

      if (next_slide) {
        const poster = next_slide.querySelector(".product-media__poster");
        const video = next_slide.querySelector("video");
        if (video) {
          poster.style.display = "block";
          video.pause();
        }
      }
    }, 100);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    initDefaultOptions();
    setOPtions();
    videoPlay();
  }, 350);
});
